import React from 'react';
import { useRequest } from 'ahooks';
import { api } from "@redux/api";
import PeiChart from "@containers/facility/Overview/PieChart";
import { useAuth } from '@/hooks/use-auth';
import { Nopermission } from '@/components/Nopermission';
import { useNavigate } from 'react-router-dom';
import { emitEvent } from '@/hooks/useEventBus';
import { useDispatch, useSelector } from 'react-redux';
import appActions from '@redux/app/actions';

const WorkorderByStatusChart = () => {
    const workorderPermission = useAuth('workorder', 1);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const facilityId = useSelector(state => state?.Facility?.selected?.Id);
    const { data: workorderData } = useRequest(
        () => api.allworkorderview(),
        {
            ready: workorderPermission,
            cacheKey: `workorder-status-chart-data-${facilityId}`,
            staleTime: 1 * 60 * 1000, // 1分钟缓存
        }
    );

    if (!workorderPermission) {
        return <Nopermission />;
    }

    const groupedStatusData = workorderData?.data?.grouped_status_data;

    if (!groupedStatusData) {
        return null;
    }

    const handleWorkOrderStatusClick = (e) => {
        emitEvent('CLOSE_WORKORDER');
        const url = '/facility/workorder?status=' + e.data.name;
        navigate(url);
        dispatch(appActions.changeCurrent(['workorder']));
    };

    return (
        <PeiChart
            data={groupedStatusData}
            height={200}
            colors={{
                'Completed': '#4ade80',
                'Verifying': '#60a5fa',
                'On-Hold': '#9ca3af',
                'InProgress': '#fb923c',
                'Not Started': '#ef4444'
            }}
            title={'Workorder by Status'}
            handleChartClick={handleWorkOrderStatusClick}
        />
    );
};

export default WorkorderByStatusChart; 